import React from 'react';
import './products.scss';
import { connect } from 'react-redux';
import ProductCard from 'components/web/ProductCard/ProductCard';
import {
  getCategoryPLPDetails,
  resetPLP,
} from 'hb-redux-store/feature/products/product.action';
import Loader from 'components/mweb/Skeletons/Loader/Loader';
import {
  postAddItem,
  postRemoveItem,
} from 'hb-redux-store/feature/cart/cart.action';
import { getCPMapping } from '../../../CPMapping';
import history from 'hb-redux-store/history';
import { Helmet } from 'react-helmet';

class PLP extends React.Component {
  state = {
    showTitle: true,
    desktopIndex: 5,
  };

  componentDidMount() {
    this.updateSize();
    window.addEventListener('resize', this.updateSize);
    this.fetchProductDetails();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateSize);
    this.props.resetPLP();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.category !== this.props.category) this.fetchProductDetails();
  }

  getDesktopIndex = screenWidth => {
    if (screenWidth >= 1024) return 7;
    else return 8;
  };

  updateSize = () => {
    const screenWidth =
      window.innerWidth > 0 ? window.innerWidth : window.screen.width;
    const desktopIndex = this.getDesktopIndex(screenWidth);
    this.setState({ desktopIndex });
  };

  fetchProductDetails = () => {
    const { category, products = null } = this.props;
    if (!products) {
      const cpMapping = getCPMapping();
      const { categoryId, isProvisional } =
        cpMapping?.categories.find(
          c => c.categorySeoName.toLowerCase() === category.toLowerCase()
        ) || {};
      this.props.getCategoryPLPDetails({ categoryId, isProvisional });
    }
  };

  render() {
    const {
      categoryPLPDetails,
      loadingCategoryPLP,
      postAddItem,
      postRemoveItem,
      section,
    } = this.props;
    const USP_INDEX = 6;
    const DESKTOP_INDEX = this.state.desktopIndex;

    const isCategories = history.location.pathname !== '/';

    let productsLT6 = categoryPLPDetails?.products || [];
    let productsGT6 = [];
    if (categoryPLPDetails?.products?.length >= USP_INDEX) {
      productsLT6 = [];
      categoryPLPDetails.products.map((p, index) => {
        if (!isCategories) {
          if (index < DESKTOP_INDEX) productsLT6.push(p);
        } else {
          if (index < USP_INDEX) productsLT6.push(p);
          else productsGT6.push(p);
        }
      });
    }
    return (
      <div className="desktop-plp">
        {/* <SecondaryNav
          title={categoryPLPDetails && categoryPLPDetails.categoryName}
          showTitle={showTitle}
        /> */}
        {loadingCategoryPLP && <Loader />}
        {categoryPLPDetails && !loadingCategoryPLP && (
          <React.Fragment>
            {!section && (
              <Helmet>
                <title>{`Buy Fresh ${categoryPLPDetails.categoryName} Online in Mumbai | Fresh Early Morning Delivery - VegXL`}</title>
                {/*  Twitter Card data  */}
                <meta
                  name="twitter:card"
                  value={`Buy Fresh ${categoryPLPDetails.categoryName} Online in Mumbai | Fresh Early Morning Delivery - VegXL`}
                />
                {/*  Open Graph data  */}
                <meta
                  property="og:title"
                  content={`Buy Fresh ${categoryPLPDetails.categoryName} Online in Mumbai | Fresh Early Morning Delivery - VegXL`}
                />
                <meta
                  property="og:image"
                  content={categoryPLPDetails.desktopBannerImage}
                />
              </Helmet>
            )}
            {productsLT6.map(product => {
              return (
                <div
                  className={`${
                    !isCategories
                      ? 'desktop-plp--product-card'
                      : 'desktop-plp--product-card-categories'
                  }`}
                  key={product.productId}
                >
                  <ProductCard
                    product={product}
                    onIncrement={postAddItem}
                    onDecrement={postRemoveItem}
                    source="PLP"
                  />
                </div>
              );
            })}
            {productsGT6.map(product => {
              return (
                <div
                  className={`${
                    !isCategories
                      ? 'desktop-plp--product-card'
                      : 'desktop-plp--product-card-categories'
                  }`}
                  key={product.productId}
                >
                  <ProductCard
                    product={product}
                    onIncrement={postAddItem}
                    onDecrement={postRemoveItem}
                    source="PLP"
                  />
                </div>
              );
            })}
            {!isCategories && categoryPLPDetails?.products?.length >= 8 && (
              <div
                className="desktop-plp--product-card cursor-hover"
                onClick={() => history.push(`/${this.props.category}`)}
              >
                <div className="desktop-product-card--empty-card">
                  <div className="desktop-product-card--link">View More</div>
                </div>
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ productReducer }) => ({
  categoryPLPDetails: productReducer.categoryPLPDetails,
  loadingCategoryPLP: productReducer.loadingPdp,
});

const mapDispatchToProps = {
  getCategoryPLPDetails,
  postAddItem,
  postRemoveItem,
  resetPLP,
};

export default connect(mapStateToProps, mapDispatchToProps)(PLP);
